<div class="quick-bar">
  <div class="quick-bar__item quick-bar__dropdown" (click)="toggleCurrency()" role="button" aria-haspopup="listbox" [attr.aria-expanded]="openCurrency">
    <button type="button" class="quick-bar__btn" aria-label="Moneda">
      <i class="bi bi-coin"></i>
    </button>
    @if (openCurrency) {
      <ul class="quick-bar__list" role="listbox">
        @if (!currencies.length) { <li class="quick-bar__option">Cargando...</li> }
        @for (c of currencies; track c.id) {
          <li role="option"
              [attr.aria-selected]="selectedCurrencyCode === c.code"
              (click)="selectCurrency(c.code)"
              class="quick-bar__option"
              [class.is-active]="selectedCurrencyCode === c.code">
            {{ c.code }} <small style="opacity:.65">{{ c.symbol }}</small>
          </li>
        }
      </ul>
    }
  </div>

  <div class="quick-bar__item quick-bar__dropdown" (click)="toggleLanguage()" role="button" aria-haspopup="listbox" [attr.aria-expanded]="openLanguage">
    <button type="button" class="quick-bar__btn" aria-label="Idioma">
      <i class="bi bi-globe"></i>
    </button>
    @if (openLanguage) {
      <ul class="quick-bar__list" role="listbox">
        @for (l of languages; track l) {
          <li role="option"
              [attr.aria-selected]="selectedLanguage === l"
              (click)="selectLanguage(l)"
              class="quick-bar__option"
              [class.is-active]="selectedLanguage === l">
            {{ l }}
          </li>
        }
      </ul>
    }
  </div>

  <!-- Botón de persona: si está logueado muestra dropdown, si no va al login -->
  @if (isLoggedIn$ | async) {
    <div class="quick-bar__item quick-bar__dropdown" (click)="toggleProfile()" role="button" aria-haspopup="listbox" [attr.aria-expanded]="openProfile">
      <button type="button" class="quick-bar__btn" aria-label="Mi perfil">
        <i class="bi bi-person"></i>
      </button>
      @if (openProfile) {
        <ul class="quick-bar__list" role="listbox" style="min-width: 160px;">
          @if (me$ | async; as me) {
            <li class="quick-bar__option" style="pointer-events: none; opacity: 0.7; font-size: 0.8rem;">
              {{ me.name }} {{ me.last_name }}
            </li>
            <li style="border-top: 1px solid rgba(255,255,255,0.15); margin: 4px 0;"></li>
          }
          <li class="quick-bar__option" routerLink="/user/profile" (click)="openProfile = false">
            <i class="bi bi-person me-2"></i> Mi Perfil
          </li>
          <li class="quick-bar__option" routerLink="/user/my-purchases" (click)="openProfile = false">
            <i class="bi bi-bookmark-check me-2"></i> Mis Compras
          </li>
          <li style="border-top: 1px solid rgba(255,255,255,0.15); margin: 4px 0;"></li>
          <li class="quick-bar__option" style="color: #ff6b6b;" (click)="onLogout($event)">
            <i class="bi bi-power me-2"></i> Cerrar sesión
          </li>
        </ul>
      }
    </div>
  } @else {
    <a routerLink="/auth/sign-in" class="quick-bar__login-link" aria-label="Iniciar sesión">
      Iniciar sesión
    </a>
  }
</div>